import { memo, useCallback, useContext, useMemo } from 'react';
import { CallTopicContext } from '../../../contexts/CallTopicContext';
import { MediaPlaybackTimeContext } from '../../context/MediaPlaybackTimeContext';
import { MediaPlaybackControlsContext } from '../../context/MediaPlaybackControlsContext';
import { LeftIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const PrevCallTopicButton = () => {
  const currentTime = useContext(MediaPlaybackTimeContext);
  const {
    setPlayerHeadLocation
  } = useContext(MediaPlaybackControlsContext);
  const {
    selectedTopicUtteranceIndex,
    selectedTopicUtterances
  } = useContext(CallTopicContext);
  const hasPrevUtterance = useMemo(() => {
    if (!selectedTopicUtterances || selectedTopicUtteranceIndex === null) {
      return false;
    }
    return selectedTopicUtteranceIndex > 0 || currentTime > selectedTopicUtterances[0].endTimeSeconds;
  }, [currentTime, selectedTopicUtteranceIndex, selectedTopicUtterances]);
  const handlePrevTopicUtteranceClick = useCallback(() => {
    if (selectedTopicUtteranceIndex !== null && hasPrevUtterance && selectedTopicUtterances) {
      const newTopicIndex = currentTime > selectedTopicUtterances[selectedTopicUtteranceIndex].endTimeSeconds ? selectedTopicUtteranceIndex : selectedTopicUtteranceIndex - 1;
      const newTopic = selectedTopicUtterances[newTopicIndex];
      setPlayerHeadLocation(newTopic.startTimeSeconds);
    }
  }, [currentTime, hasPrevUtterance, selectedTopicUtteranceIndex, selectedTopicUtterances, setPlayerHeadLocation]);
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "callTopicsNavButtons-prev",
    size: "xs",
    use: "transparent",
    disabled: !hasPrevUtterance,
    onClick: handlePrevTopicUtteranceClick,
    children: /*#__PURE__*/_jsx(LeftIcon, {})
  });
};
export default /*#__PURE__*/memo(PrevCallTopicButton);